<template>
    <a-spin :spinning="confirmLoading">
        <j-form-container :disabled="formDisabled">
            <a-form-model :model="model" :rules="validatorRules" ref="form" slot="detail">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="测点编码" prop="pointCodes">
                    <j-select-model-points :multiple="true" @select="changeRow" placeholder="请选择测点" v-model="model.pointCodes" />
                </a-form-model-item>
            </a-form-model>
        </j-form-container>
    </a-spin>
</template>

<script>
    import { httpAction, getAction } from '@/api/manage'
    import { validateDuplicateValue } from '@/utils/util'

    export default {
        name: 'IotModelPointsGroupMenberForm',
        components: {},
        props: {
            //表单禁用
            disabled: {
                type: Boolean,
                default: false,
                required: false
            }
        },
        data() {
            return {
                model: {
                    pointCodes: {}
                },
                pointList: [],
                labelCol: {
                    xs: { span: 24 },
                    sm: { span: 5 },
                },
                wrapperCol: {
                    xs: { span: 24 },
                    sm: { span: 16 },
                },
                confirmLoading: false,
                validatorRules: {
                    pointCodes: [
                        { required: true, message: '请选择测点编码!' },
                    ],
                },
                url: {
                    add: "/monitor/iotModelPointsGroupMenber/add",
                    edit: "/monitor/iotModelPointsGroupMenber/edit",
                    queryById: "/monitor/iotModelPointsGroupMenber/queryById"
                }
            }
        },
        computed: {
            formDisabled() {
                return this.disabled
            },
        },
        created() {
            //备份model原始值
            this.modelDefault = JSON.parse(JSON.stringify(this.model));
        },
        methods: {
            changeRow(v) {
                this.pointList = v.map((item) => {
                    let c = { pointCode: item.pointCode, pointName: item.pointName }
                    return c
                })
            },
            add(data) {
                this.modelDefault.pointCodes = data
                this.edit(this.modelDefault)
            },
            edit(record) {
                this.model = Object.assign({}, record);
                this.visible = true;
            },
            submitForm() {
                const that = this;
                // 触发表单验证
                this.$refs.form.validate(valid => {
                    if (valid) {
                        that.$emit('ok', that.pointList);
                    }
                })
            },
        }
    }
</script>